import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    
 } from 'Actions';

class StrokesChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            loader:false,
            contact:'',
            shotstring:'',
            showModal:false,
            
        };
    }

    
    


render() {

    const { puttperformancechart,  loading} = this.props; 
    const datacount=puttperformancechart.length;
    const barData = puttperformancechart.strokegained; 
    const data1max=50; 

    const CustomBarLabel = ({ payload, x, y, value }) => {
        return <text x={x+10} y={y} dy={-6} fill="#757474" textAnchor="middle" >{value}</text>;
    }
    return(
        <div>   
            <RctCollapsibleCard>
                <div className="row">
                    <div className="col-sm-12 col-lg-12">
                        <h2> STROKES GAINED REPORT</h2>                         
                    </div>
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-12">
                            
                    <ResponsiveContainer width={800} height={300} style={{margin:"1px"}}> 
                            <BarChart data={barData}>                                
                                <XAxis dataKey="x" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}} style={{ fontSize: '0.7rem' }}/>
                                <YAxis stroke={ChartConfig.axesColor} domain={[-50, 50]}/>
                                <CartesianGrid vertical={false} horizontal={false} stroke={ChartConfig.chartGridColor} />                                
                                <Bar dataKey="y" fill={"#FF0000"} label={{ position: "top", fill:"#a3a3a3" }} barSize={20}/> 
                            </BarChart>
                        </ResponsiveContainer>
                            
                    </div>
                    
                    
                    </>
                    }          
                </div>

                </RctCollapsibleCard>
                
                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ puttperformance}) => {
    const { puttperformancechart, loading } = puttperformance;
    return { puttperformancechart, loading };
   
}


export default connect(mapStateToProps, {
    
})(StrokesChart);
